import React, { useEffect, useReducer } from 'react';
import get from 'lodash/get';

import QueryStatus from '../../components/query-status/query-status';
import DataWarning from '../../components/data-warning/data-warning';
import Loader from '../../components/loader/loader';
import EmbedFooter from '../../components/EmbedFooter';
import MapContainer from '../../components/map-container/map-container.jsx';
import Tooltip from '../../components/Tooltip';
import TradeReadout from '../../components/TradeReadout';
import { MapWrapper, MapWrapperMain } from '../../components/MapWrapper';
import { TradeQueryReadout } from '../../components/QueryReadout';

import fetchResultsSet from '../../utilities/fetchResultsSet.js';

import { reducer, getInitialState } from './reducer.js';

import './styles.scss';

// TODO: Disable interaction on mobile, make entire embed a link to explorer?
export default function TradeEmbed() {
  const [state, dispatch] = useReducer(reducer, getInitialState());

  useEffect(() => {
    function handleResultSetLoaded(id, data) {
      dispatch({ type: 'RESULTS_LOADED', id: id, data: data });
    }

    fetchResultsSet(state.query, 'trades', handleResultSetLoaded);
    fetchResultsSet(state.query, 'totals', handleResultSetLoaded);
  }, [state.query, dispatch]);

  function handleFlowHover(data, point) {
    dispatch({ type: 'SET_HOVERED_FLOW', data: data, point: point });
    dispatch({ type: 'SET_SHOW_TOOLTIP', show: !!data && !!point });
  }

  function handleCountryHover(country) {
    dispatch({ type: 'SET_HOVERED_COUNTRY', country: country });
  }

  return (
    <div className="embed-view">
      <div className="embed-view__main">
        <Loader visible={state.results.trades.status !== 'ready'} transparent={true} />
        <div className="embed-view__header">
          <TradeQueryReadout query={state.query} />
        </div>
        <div className="embed-view__body">
          <DataWarning query={state.query} data={get(state.results.trades.data, 'main')} />
          <MapContainer
            kind={state.query.autozoom ? 'embed-zoomed' : 'embed'}
            query={state.query}
            data={get(state.results.trades.data, 'main')}
            total={get(state.results.trades.data, 'total')}
            hoveredFlow={state.hoveredFlow}
            hoveredCountry={state.hoveredCountry}
            autoZoom={state.query.autozoom}
            handleFlowHover={handleFlowHover}
            handleCountryHover={handleCountryHover}
          />
        </div>
        <div className="embed-view__footer">
          <EmbedFooter url={`${__config.originPath}?${state.query.toString()}`} />
        </div>
      </div>
      {state.showTooltip && state.hoveredFlow && (
        <Tooltip>
          <TradeReadout
            data={state.hoveredFlow}
            totals={state.results.totals}
            query={state.query}
          />
        </Tooltip>
      )}
    </div>
  );
}
